<template>
  <div class="notifications">
    <div v-for="(notification, index) in notifications" :key="index">
      <v-alert shaped elevation="5" dismissible dense :type="getNotificationType(notification.type)">
        {{ notification.text }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import { NotificationsService } from '@/modules/notifications/notifications-service';

export default {
  data: () => ({
    notifications: [],
  }),
  methods: {
    getNotificationType (type) {
      switch (type) {
        case 'warning': return 'error';
        case 'success': return 'success';
        case 'primary': return 'primary';
        case 'danger': return 'warning';
        default: return '';
      }
    },
  },
  mounted () {
    setInterval(() => {
      this.notifications.forEach((notification, index) => {
        if ((new Date(notification.ttl)) - (new Date()) < 0) {
          NotificationsService.instance.remove(index);
        }
      });
    }, 1000);

    this.notifications = NotificationsService.instance.notifications;
    NotificationsService.instance.subscribe('update', () => {
      this.notifications = NotificationsService.instance.notifications;
    });
  },
};
</script>

<style lang="scss" scoped>
  .notifications {
    position: fixed;
    top: 100px;
    right: 50px;
    width: 300px;
    z-index: 99999999;

    @media (max-width: 500px) {
      left: 20px;
      right: 20px;
      width: auto;
    }
  }
</style>
